/*
 * Copyright (c) 2026. Bluemate B.V.
 */
import React from 'react';

import mail from '@iconify/icons-feather/mail';

import {useTranslation} from 'react-i18next';

import BluemateSetupCard from './bluemateSetupCard';

interface Props {
    completed?: boolean;
    onClick?: () => void;
    onCheckClick?: () => void;
    className?: string;
}

export default function BluemateEmailSetupCard(props: Props) {
    const {completed, onClick, onCheckClick, className} = props;
    const {t} = useTranslation();

    return (
        <BluemateSetupCard
            className={className}
            title={t('controls.setupCard.emailSetup.title', 'E-mails instellen')}
            subtitle={t('controls.setupCard.emailSetup.subtitle', 'Om automatisch te e-mailen')}
            icon={mail}
            completed={completed}
            onClick={onClick}
            onCheckClick={onCheckClick}
        />
    );
}
